import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=d147fb86&scoped=true&"
import script from "./goodsItem.vue?vue&type=script&lang=js&"
export * from "./goodsItem.vue?vue&type=script&lang=js&"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=d147fb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d147fb86",
  null
  
)

export default component.exports